
let FormValidation = require('FormValidation');
let bootstrapValidation = require('form-validation-bootstrap');
let engFormValidation = require('@commonjs_dir/input-validators/locales/en_US.js');

let validateOrderForm = function () {

    let form = document.querySelector('.admin-validate-form');

    if(!form) {
        return;
    }

    let fv = FormValidation.formValidation(
        form,
        {
            localization: engFormValidation,
            plugins: {
                trigger: new FormValidation.plugins.Trigger({
                    event: {
                        title: 'keyup',
                        summary: 'blur',
                    },
                }),
                bootstrap3: new bootstrapValidation(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                defaultSubmit: new FormValidation.plugins.DefaultSubmit(),
                declarative: new FormValidation.plugins.Declarative({
                    html5Input: true,
                }),
            }
        }
    );

    // Called when a field is invalid
    fv.on('core.field.invalid', function(event) {

        let element = document.getElementsByName(event)[0];
        let tabPane = $(element).parents('.tab-pane');
        let tabId    = tabPane.attr('id');

        $('a[href="#' + tabId + '"][data-toggle="tab"]')
            .addClass('tab-error')
            .parent()
            .find('i')
            .removeClass('fa-check')
            .addClass('fa-times');
    }).on('core.form.valid', function() {
        let event = new Event('submit');
        form.dispatchEvent(event);
    });
};



validateOrderForm();


//



